module.exports = __webpack_public_path__ + "static/media/merriweather-bold-webfont.3a8907c9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-bold-webfont.ttf
// module id = 297
// module chunks = 0